import { useState } from "react";
import { useSiteData } from "../app/SiteDataContext";
import Seo from "../components/shared/Seo";
import NoticeBanner from "../components/ui/NoticeBanner";
import SectionHeading from "../components/ui/SectionHeading";
import InputField from "../components/ui/InputField";
import TextAreaField from "../components/ui/TextAreaField";
import Button from "../components/ui/Button";

function ContactPage() {
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const { settings, usingFallback } = useSiteData();
  const resolvedChannels = settings.contactInfo?.channels || [];
  const resolvedSocialLinks = settings.socialLinks || [];

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormState((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const nextErrors = {};

    if (!formState.name.trim()) {
      nextErrors.name = "Isim gerekli.";
    }

    if (!formState.email.includes("@")) {
      nextErrors.email = "Gecerli bir e-posta girin.";
    }

    if (formState.message.trim().length < 12) {
      nextErrors.message = "Mesajiniz en az 12 karakter olmali.";
    }

    setErrors(nextErrors);
    setSubmitted(Object.keys(nextErrors).length === 0);
  };

  return (
    <div className="page-stack">
      <Seo
        title="Iletisim"
        description="Yeni proje, danismanlik veya is ortakligi icin Onur Atabay ile iletisime gecin."
        path="/iletisim"
        keywords={["iletisim", "frontend danismanlik", "proje talebi"]}
      />
      {usingFallback ? (
        <NoticeBanner>
          Iletisim ve sosyal link alanlari su anda local fallback verisiyle
          gosteriliyor. Ileride WordPress ayarlar endpoint'i ile
          degistirilebilir.
        </NoticeBanner>
      ) : null}
      <section className="glass-panel page-hero">
        <SectionHeading
          eyebrow="Contact"
          title="Temiz scope, iyi brief ve kaliteli execution icin dogru yerdesiniz."
          description="Iletisim formu simdilik dummy calisiyor; mimari, validasyon akisi ve UI durumlari production mantiginda kuruldu."
        />
      </section>

      <section className="content-section contact-layout">
        <div className="glass-panel form-panel">
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <InputField
              label="Isim"
              name="name"
              placeholder="Adinizi yazin"
              value={formState.name}
              onChange={handleChange}
            />
            {errors.name ? <p className="field-error">{errors.name}</p> : null}

            <InputField
              label="E-posta"
              name="email"
              type="email"
              placeholder="ornek@mail.com"
              value={formState.email}
              onChange={handleChange}
            />
            {errors.email ? <p className="field-error">{errors.email}</p> : null}

            <InputField
              label="Konu"
              name="subject"
              placeholder="Kisaca proje konusu"
              value={formState.subject}
              onChange={handleChange}
            />

            <TextAreaField
              label="Mesaj"
              name="message"
              rows="6"
              placeholder="Projenin kapsamindan ve hedefinden kisaca bahsedin"
              value={formState.message}
              onChange={handleChange}
            />
            {errors.message ? (
              <p className="field-error">{errors.message}</p>
            ) : null}

            <Button className="full-width" type="submit" variant="primary">
              Mesaji Gonder
            </Button>

            {submitted ? (
              <p className="form-success">
                Demo basarili. Buraya daha sonra gercek servis entegrasyonu
                baglanabilir.
              </p>
            ) : null}
          </form>
        </div>

        <div className="side-stack">
          <div className="glass-panel">
            <SectionHeading
              eyebrow="Direct"
              title="Hizli iletisim bilgileri"
              description="Daha guven veren, net bir iletisim akisi icin ana bilgiler yan panelde tutuluyor."
            />
            <div className="channel-list">
              {resolvedChannels.map((item) => (
                <article key={item.label} className="channel-item">
                  <h3>{item.label}</h3>
                  <strong>{item.value}</strong>
                  <p>{item.description}</p>
                </article>
              ))}
            </div>
          </div>

          <div className="glass-panel">
            <h3 className="panel-title">Sosyal baglantilar</h3>
            <div className="tag-row">
              {resolvedSocialLinks.map((item) => (
                <a
                  key={item.label}
                  className="tag-pill interactive-pill"
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item.label} {item.value}
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
